import React from "react";
import PropTypes from "prop-types";
import { Alert, FormControl, MenuItem, Stack, TextField } from "@mui/material";
import { contentFieldSx } from "../../content/contentEditorStyles";

const NewsletterPublishTemplateSection = ({
  templatesLoading,
  templateLoading,
  selectedTemplateKey,
  onTemplateChange,
  templateOptions,
  subjectWarning,
  compileErrors,
  subject,
  onSubjectChange,
}) => (
  <Stack spacing={2}>
    <FormControl fullWidth sx={contentFieldSx}>
      <TextField
        select
        label="Template email"
        value={selectedTemplateKey}
        onChange={(e) => onTemplateChange(e.target.value)}
        disabled={templatesLoading || templateLoading}
      >
        <MenuItem value="">— Seleziona template —</MenuItem>
        {templateOptions.map((option) => (
          <MenuItem key={option.key} value={option.key}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    </FormControl>

    {subjectWarning ? (
      <Alert severity="warning">
        Il template selezionato non ha un oggetto email. Imposta l&apos;oggetto nel pannello proprietà dell&apos;editor
        oppure inseriscilo qui sotto prima dell&apos;invio.
      </Alert>
    ) : null}

    {compileErrors.length ? (
      <Alert severity="error">Il template contiene errori di compilazione HTML e non può essere inviato.</Alert>
    ) : null}

    <TextField
      fullWidth
      label="Oggetto email"
      value={subject}
      onChange={(e) => onSubjectChange(e.target.value)}
      disabled={!selectedTemplateKey}
      sx={contentFieldSx}
    />
  </Stack>
);

NewsletterPublishTemplateSection.propTypes = {
  templatesLoading: PropTypes.bool,
  templateLoading: PropTypes.bool,
  selectedTemplateKey: PropTypes.string,
  onTemplateChange: PropTypes.func.isRequired,
  templateOptions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  subjectWarning: PropTypes.bool,
  compileErrors: PropTypes.arrayOf(PropTypes.string),
  subject: PropTypes.string,
  onSubjectChange: PropTypes.func.isRequired,
};

export default NewsletterPublishTemplateSection;
